import { render, staticRenderFns } from "./SkuLineList.vue?vue&type=template&id=704ddb68"
import script from "./SkuLineList.vue?vue&type=script&lang=js"
export * from "./SkuLineList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('704ddb68')) {
      api.createRecord('704ddb68', component.options)
    } else {
      api.reload('704ddb68', component.options)
    }
    module.hot.accept("./SkuLineList.vue?vue&type=template&id=704ddb68", function () {
      api.rerender('704ddb68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/report/order/GoodsInfoTab/SkuLineList.vue"
export default component.exports